import { render } from "./CreditsView.vue?vue&type=template&id=1426f18e&scoped=true"
import script from "./CreditsView.vue?vue&type=script&lang=js"
export * from "./CreditsView.vue?vue&type=script&lang=js"

import "./CreditsView.vue?vue&type=style&index=0&id=1426f18e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1426f18e"]])

export default __exports__